import { render, staticRenderFns } from "./CheckboxColor.vue?vue&type=template&id=9511e55e&scoped=true&"
import script from "./CheckboxColor.vue?vue&type=script&lang=js&"
export * from "./CheckboxColor.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxColor.vue?vue&type=style&index=0&id=9511e55e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9511e55e",
  null
  
)

export default component.exports